export const locale = {
  lang: 'en',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': 'My profile',
      'ENLACES': {
        'configuracion': 'Account settings',
        'notificaciones': 'User notifications',
        'mensajes': 'Received messages'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': 'Account settings',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': 'Change email',
              'SUBTITULO': 'You can change the email address of your account',
              'INPUTS': {
                'MAIL': 'new e-mail adress',
                'TOKEN': 'Verification code',
                'PASS': 'New Password',
                'CONFIRMPASS': 'Confirm Password'
              },
              'BOTONES': {
                'CAMBIAMAIL': 'Change email',
                'VERTOKEN': 'Check code',
                'FINALMAIL': 'Change email address',
              }
            },
            'CAMBIARPASS': {
              'TITULO': 'Change Password',
              'SUBTITULO': 'You can change your account password',
              'BOTONES': {
                'FINALPASS': 'Change Password'
              }
            },
            'AUTENTICACION': {
              'TITULO': 'Two-step authentication',
              'SUBTITULO': 'You can increase the security of your account by activating two-step authentication',
              'BOTONES': {
                'ACTIVAR': 'Activate',
                'DESACTIVAR': 'Deactivate'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': 'A message has been sent to the specified email with a verification code, enter the verification code received to continue the process',
        'CAMBIARMAIL_PASO1_NOTOK': 'Cannot continue, the email entered is already registered in the system',
        'CAMBIARMAIL_PASO1_SAME': 'Cannot continue, the email entered is the same as the account currently has',
        'CAMBIARMAIL_PASO2_OK': 'The verification code is correct, to continue, you need to enter a new password below',
        'CAMBIARMAIL_PASO2_NOTOK': 'The verification code is incorrect, please check that you entered it correctly and check it again',
        'CAMBIARMAIL_PASO3_NOTOK': 'Unable to continue, passwords do not match, please re-enter them correctly',
        'CAMBIARMAIL_PASO3_OK': 'The account data was updated correctly, to finish the process the session will be closed, re-enter the platform using the new access data',
        'CAMBIAPASS_OK': 'The account password was successfully updated',
        'CAMBIAPASS_NOTOK': 'Unable to continue, passwords do not match, please re-enter them correctly',
        'AUTHOK': 'Authentication status updated successfully'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'Close      ',
      'MYPROFILLE':'My profile',

      'TITLE':'Change password',
       'BTNBACK':'Back',
       'MENUTITLE':'Menu',
       'MENU':{
         'OPC1':'My data'
       },
       'NAME':'Name',
       'EMAIL':'Email',
       'CODE':'Verification code',
       'NEWPASS':'New Password',
       'REPASS':'Re-type Password',
       'CHANGE':'Change password',
       'SENDCODE':'Send verification code',
       'CHECKCODE':'Verify code',
       'ERROR':{
        'ERROR01':'Required field',
        'ERROR02':'Error, something happened',
        'ERROR03':'The code does not match',
        'ERROR04':'Passwords do not match',
        'ERROR05':'Must be 3 characters minimum',
        'ERROR06':'The email already exists, please try with another one',
        'ERROR07':'Company name does not match'
      },
      'SUCCESS':{
        'OK':'Ok',
       'MESESAGE1':'Data updated correctly',
       'MESESAGE2':'Code sent ... Please check your email',
       'MESESAGE3':'Correct code'
      }
    }
  }
};
